import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import checkFunctions from '../../CheckFunction';
import Iban from '../../utils/Iban';

const TextInput = ({ disabled, errorMessage, errorRequiredMessage, errorMinCharactersMessage, isIban = false, isCF = false, isPIVA = false, label, minCharacters, name, onChange, required, text, type = 'text', validate, value, onClick }) => {

    function validation(value) {
        // First we Check Custom Validation
        if (validate && !validate(value)) {
            if (errorMessage)
                return errorMessage;
            return 'Validazione non rispettata';
        }
        else if (required && _.isEmpty(value)) {
            if (errorRequiredMessage)
                return errorRequiredMessage;
            return 'Campo obbligatorio';
        }
        else if (required && minCharacters && value.length < minCharacters) {
            if (errorMinCharactersMessage)
                return errorMinCharactersMessage;
            return 'Numero minimo di caratteri: ' + minCharacters;
        } else if (type === 'email' && !checkFunctions.checkEmail(value) && !_.isUndefined(value) && !_.isEmpty(value)) {
            if (errorMessage)
                return errorMessage;
            return 'Email non corretta';
        } else if (required && isCF && !checkFunctions.checkCF(value)) {
            if (errorMessage)
                return errorMessage;
            return 'Codice Fiscale non corretto';
        } else if (required && isPIVA && !checkFunctions.checkPIVA(value)) {
            if (errorMessage)
                return errorMessage;
            return 'Partita IVA non corretta';
        } else if ((required || (!_.isNil(value) && !_.isEmpty(value))) && isIban) {
            const ib = new Iban();
            if (!ib.isValid(value)) {
                if (errorMessage)
                    return errorMessage;
                return 'IBAN non corretto';
            }
        }

        return '';
    }

    /**
     * For us is import to return this
     * errorMessage and Target: { name: '', value: '' }
     * @param {Coming from the input HTML} event 
     */
    function onChangeLocal(event) {
        if (onChange) {
            onChange({
                target: {
                    name: event.target.name,
                    value: event.target.value,
                    errorMessage: validation(event.target.value)
                }
            });
        }
    }

    const resultErrorMessage = validation(value);

    return (
        <div className='formComponent'>
            <div className="input-group">
                {label ? <label className='input-group-addon' htmlFor={name}>{label}</label> : ''}
                <input
                    name={name}
                    type={type}
                    disabled={disabled}
                    placeholder={text}
                    className='form-control'
                    onChange={onChangeLocal}
                    onClick={onClick}
                    value={value} />
            </div>
            {resultErrorMessage !== '' && <div style={{ color: '#a94442' }}>{resultErrorMessage}</div>}
        </div>
    );
};

TextInput.propTypes = {
    disabled: PropTypes.string, // Set 'disabled' to disabled the input
    errorMessage: PropTypes.string, // Used for custom validation
    errorRequiredMessage: PropTypes.string, // Used with required
    errorMinCharactersMessage: PropTypes.string, // Used with min number of chars
    isIban: PropTypes.bool,
    isCF: PropTypes.bool, // True if this is a CF Field
    isPIVA: PropTypes.bool, // True if this is a PIVA Field
    label: PropTypes.string, // Label
    minCharacters: PropTypes.number, // Minimum Number of chars required
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onError: PropTypes.func,
    required: PropTypes.bool, // If this field is required
    text: PropTypes.string,
    type: PropTypes.string, // This define the Input Type cos it could be password, email or more
    validate: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default TextInput;
